import React from "react";

const ResourcesContext = React.createContext({});

export default ResourcesContext;
